import { trim } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import ProgressBar from 'components/ProgressBar';
import { mediumUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';

import FreeShippingInidicatorPeaceIcon from './FreeShippingInidicatorPeaceIcon';

const FreeShippingIndicator = ({
  cartValueRemaining,
  cartPercentageComplete,
  showProgressBar,
  showPeaceIcon,
  largeText,
}) => {
  const hasFreeShipping = cartPercentageComplete === 100;
  const messagingClassName = largeText
    ? 'FreeShippingIndicator__messaging_large'
    : 'FreeShippingIndicator__messaging';

  return (
    <div className="FreeShippingIndicator">
      <div className="FreeShippingIndicator__messaging-container">
        {hasFreeShipping ? (
          <div>
            <span className={messagingClassName}>{I18n.localize('cart.freeShippingComplete')}</span>
            {showPeaceIcon && <FreeShippingInidicatorPeaceIcon />}
          </div>
        ) : (
          <span className={messagingClassName}>
            {trim(I18n.localize('cart.freeShippingRemaining.part1'))}{' '}
            <span className={`${messagingClassName} FreeShippingIndicator__messaging--emphasis`}>
              {I18n.localize('cart.freeShippingRemaining.part2', {
                value: cartValueRemaining,
              })}
            </span>{' '}
            {trim(I18n.localize('cart.freeShippingRemaining.part3'))}
          </span>
        )}
      </div>
      {showProgressBar && <ProgressBar progress={cartPercentageComplete} />}

      <style jsx>
        {`
          .FreeShippingIndicator__messaging-container {
            text-align: center;
          }

          .FreeShippingIndicator__messaging {
            color: ${Theme.get('colors-black')};
            font-size: ${Theme.get('font-size-smaller-px')};
            font-weight: ${Theme.get('font-weight-normal')};
            letter-spacing: ${Theme.get('letter-spacing-px')};
            vertical-align: baseline;
            line-height: ${35}px;
          }

          .FreeShippingIndicator__messaging_large {
            color: ${Theme.get('colors-black')};
            font-size: ${Theme.get('font-size-description-px')};
            font-weight: ${Theme.get('font-weight-normal')};
            line-height: 20px;
          }

          @media ${mediumUp} {
            .FreeShippingIndicator__messaging {
              font-size: ${Theme.get('font-size-small-px')};
            }
          }

          .FreeShippingIndicator__messaging--emphasis {
            font-weight: ${Theme.get('font-weight-semi-bold')};
          }
        `}
      </style>
    </div>
  );
};

FreeShippingIndicator.propTypes = {
  cartValueRemaining: PropTypes.string.isRequired,
  cartPercentageComplete: PropTypes.number,
  showProgressBar: PropTypes.bool,
  showPeaceIcon: PropTypes.bool,
  largeText: PropTypes.bool,
};

FreeShippingIndicator.defaultProps = {
  cartPercentageComplete: null,
  showProgressBar: true,
  showPeaceIcon: true,
  largeText: false,
};

export default FreeShippingIndicator;
